import { useContext, useState } from 'react';
import {
  MenuItem,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField
} from '@mui/material';

import { AuthContext, stopPropagationForTab } from 'components';
import { Tracking } from 'components/Tracking';
import { useNavigate } from "react-router-dom";


export const BulkModal = (props) => {
  const { items, onClose } = props;
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [ saving, setSaving ] = useState(false);
  const [ value, setValue ] = useState("")
  const { updateItem } = useContext(AuthContext);


  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    navigate("/products_reload");
    onClose();
  }

  const handleSave = () => {
    Tracking.track('Portal - Bulk edit Notes', { items: items.length })
    let bulk_update = []

    items.forEach((item) => {
      let note = `${item.note}

${value}`.trim()

      bulk_update.push(new Promise((resolve, reject) => {
        updateItem(
          item,
          {
            note
          },
          resolve
        )
      }))
    })

    Promise.all(bulk_update).then(() => {
      handleClose()
    })
  }

  
  return (
    <>
      <MenuItem onClick={handleOpen}>
        <div>&#8288;Add note</div>
      </MenuItem>
      <Dialog fullWidth maxWidth={'sm'} onKeyDown={stopPropagationForTab} open={open} onClose={handleClose}>
        <DialogTitle>Add note</DialogTitle>
        <DialogContent>
          <DialogContentText>
          {items.length > 1 ? (
              <span>{items.length} products will be changed.</span>
            ) : (
              <span>1 product will be changed.</span>
            )}
          </DialogContentText>
          {/*  */}
          <TextField
            sx={{ mt: 2 }}
            fullWidth
            multiline
            autoFocus
            variant='standard'
            label="Enter additional notes"
            value={value}
            onChange={(e) => { setValue(e.target.value) }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button disabled={saving} onClick={() => { setSaving(true); setTimeout(handleSave, 200) }}>Save</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}